export default __webpack_public_path__ + "static/media/video.e4078ad6.jpg";